import http from './http'

export let open = {
  login: function (params) {
    return http.post('open/login', params)
  }
}
export let upload = {
  upload: function (params) {
    return http.postData('upload/test', params)
  }
}
export let conf = {
  menu: function () {
    return http.post('menu/all', null)
  }
}

export let user = {
  list: function (params) {
    return http.post('action/user/list', params)
  },
  update: function (params) {
    return http.post('action/user/update', params)
  },
  find: function (params) {
    return http.post('action/user/find', params)
  },
  bankList: function (params) {
    return http.post('action/user/query/bank/list', params)
  },

}

export let energyRecord = {
  list: function (params) {
    return http.post('action/energy/record/list', params)
  },
  remove: function (params) {
    return http.post('action/energy/record/remove', params)
  },
  invoice: function (params) {
    return http.postSticker('action/energy/record/invoice', params)
  },
  stop: function (params) {
    return http.postSticker('action/control/device/stop', params)
  }
}

export let partner = {
  add: function (params) {
    return http.post('action/partner/add', params)
  },
  list: function (params) {
    return http.post('action/partner/list', params)
  },
  update: function (params) {
    return http.post('action/partner/update', params)
  },
  corpUpdate: function (params) {
    return http.post('action/partner/corp/update', params)
  },
  find: function (params) {
    return http.post('action/partner/find', params)
  },
  device: function (data) {
    return http.post('action/device/own/partner', data)
  },
  branch: function (data) {
    return http.post('action/partner/branch/update', data)
  },
  addCorp: function (data) {
    return http.postBody('action/admin/corp/addCorp', data)
  },

}
export let partnerSet = {
  add: function (params) {
    return http.post('action/partner/set/add', params)
  },
  list: function (params) {
    return http.post('action/partner/set/list', params)
  },
  update: function (params) {
    return http.post('action/partner/set/update', params)
  },
  remove: function (params) {
    return http.post('action/partner/set/remove', params)
  },
  sharePost: function (params) {
    return http.post('action/partner/share/post', params)
  }
}

export let shareRecord = {
  list: function (params) {
    return http.post('action/share/record/list', params)
  },
  remove: function (params) {
    return http.post('action/share/record/remove', params)
  }
}

export let menu = {
  mine: async function () {
    return http.post('action/menu/mine', null)
  },
  all: function (params) {
    return http.post('action/menu/all', null)
  },
  add: function (params) {
    return http.post('action/menu/add', params)
  },
  update: function (params) {
    return http.post('action/menu/update', params)
  },
  remove: function (params) {
    return http.post('action/menu/remove', params)
  }
}

export let role = {
  all: function () {
    return http.post('action/role/all', null)
  },
  list: function (params) {
    return http.post('action/role/list', params)
  },
  add: function (params) {
    return http.post('action/role/add', params)
  },
  update: function (params) {
    return http.post('action/role/update', params)
  },
  remove: function (params) {
    return http.post('action/role/remove', params)
  },
  menus: function (params) {
    return http.post('action/role/menus', params)
  }
}

export let admin = {
  list: function (params) {
    return http.post('action/admin/list', params)
  },
  add: function (params) {
    return http.post('action/admin/add', params)
  },
  update: function (params) {
    return http.post('action/admin/update', params)
  },
  remove: function (params) {
    return http.post('action/admin/remove', params)
  }
}

//小区管理接口
export let district = {
  list: function (params) {
    return http.post('action/district/list', params)
  },
  add: function (params) {
    return http.postBody('action/district/add', params)
  },
  update: function (params) {
    return http.postBody('action/district/update', params)
  },
  remove: function (params) {
    return http.post('action/district/remove', params)
  },
  find: function (params) {
    return http.post('action/district/find', params)
  }
}
export let device = {
  list: function (params) {
    return http.post('action/device/list', params)
  },
  add: function (params) {
    return http.post('action/device/add', params)
  },
  update: function (params) {
    return http.post('action/device/update', params)
  },
  remove: function (params) {
    return http.post('action/device/remove', params)
  },
  restart: function (params) {
    return http.postSticker('action/control/device/restart', params)
  },
  bind: function (params) {
    return http.post('action/device/bind/partner', params)
  },
  exceptionList: function (params) {
    return http.post('action/device/exception/list', params)
  },
  exceptionFix: function (params) {
    return http.post('action/device/exception/fix/all', params)
  }
}
export let deviceModel = {
  all: function (params) {
    return http.post('action/device/model/all')
  },
  list: function (params) {
    return http.post('action/device/model/list', params)
  },
  add: function (params) {
    return http.post('action/device/model/add', params)
  },
  update: function (params) {
    return http.post('action/device/model/update', params)
  },
  remove: function (params) {
    return http.post('action/device/model/remove', params)
  }
}

export let approve = {
  list: function (params) {
    return http.post('action/approve/list', params)
  },
  add: function (params) {
    return http.post('action/approve/add', params)
  },
  update: function (params) {
    return http.post('action/approve/update', params)
  },
  remove: function (params) {
    return http.post('action/approve/remove', params)
  }
}

export let order = {
  list: function (params) {
    return http.post('action/order/list', params)
  },
  getOrderListByShop: function (params) {
    return http.post('action/admin/order/getOrderListByShop', params)
  },
  getOrderList: function (params) {
    return http.post('action/admin/order/getOrderList', params)
  },
  getOrderInfo: function (params) {
    return http.post('action/admin/order/getOrderInfo', params)
  },
  delivery: function (params) {
    return http.postBody('action/admin/order/delivery', params)
  },
  orderRefundList: function (params) {
    return http.post('action/admin/orderRefund/getOrderListByShop', params)
  },
  dealRefund: function (params) {
    return http.post('action/admin/orderRefund/dealRefund', params)
  },
  getOrderRefundInfo: function (params) {
    return http.post('action/admin/orderRefund/getOrderInfo', params)
  },
  refundMoney: function (params) {
    return http.post('action/admin/orderRefund/refundMoney', params)
  },

}

export let cost = {
  list: function (params) {
    return http.post('cost/list', params)
  },
}

export let prod = {
  list: function (params) {
    return http.post('action/admin/prod/getProdList', params)
  },
  examine: function (params) {
    return http.post('action/admin/prod/examine', params)
  },
  add: function (params) {
    return http.post('action/admin/prod/examine', params)
  },
  upOrDown: function (params) {
    return http.post('action/admin/prod/updateProdStatus', params)
  },
  propList: function (params) {
    return http.post('action/admin/prop/list', params)
  },
  propAdd: function (params) {
    return http.post('action/admin/prop/add', params)
  },
  propEdit: function (params) {
    return http.post('action/admin/prop/edit', params)
  },
  propDel: function (params) {
    return http.post('action/admin/prop/delete', params)
  },
  propValueList: function (params) {
    return http.post('action/admin/propValue/list', params)
  },
  propValueAdd: function (params) {
    return http.post('action/admin/propValue/add', params)
  },
  propValueEdit: function (params) {
    return http.post('action/admin/propValue/edit', params)
  },
  propValueDel: function (params) {
    return http.post('action/admin/propValue/delete', params)
  },
  shopProdList: function (params) {
    return http.post('action/admin/prod/getProdListByShop', params)
  },
  propListAll: function (params) {
    return http.post('action/admin/prop/listAll', params)
  },
  propValueListByPropId: function (params) {
    return http.post('action/admin/propValue/listByPropId', params)
  },
  addProdByShop: function (params) {
    return http.postBody('action/admin/prod/addProdByShop', params)
  },
  getProdById: function (params) {
    return http.post('action/admin/prod/getProdById', params)
  },
  updateProdByShop: function (params) {
    return http.postBody('action/admin/prod/updateProdByShop', params)
  }
}
export let code = {
  send: function (params) {
    return http.post('open/sms/code/send', params)
  }
}
export let shop = {
  list: function (params) {
    return http.post('admin/shop/getShopList', params)
  },
  examine: function (params) {
    return http.post('admin/shop/examine', params)
  },
  start: function (params) {
    return http.post('admin/shop/updateStatus', params)
  },
  stop: function (params) {
    return http.post('admin/shop/updateStatus', params)
  },
  pwd: function (params) {
    return http.post('action/shop/bank/update/pwd', params)
  },
  getShopInfo: function (params) {
    return http.postBody('action/shop/config/query/shopinfo', params)
  },
  servertel: function (params) {
    return http.get('action/shop/config/query/servertel', params)
  },
  servertelUpdate: function (params) {
    return http.post('action/shop/config/update/servertel', params)
  },
  shoplogo: function (params) {
    return http.get('action/shop/config/query/shoplogo', params)
  },
  shoplogoUpdate: function (params) {
    return http.post('action/shop/config/update/shoplogo', params)
  },
  banner: function (params) {
    return http.get('action/shop/config/query/banner', params)
  },
  updateBanner: function (params) {
    return http.post('action/shop/config/update/banner', params)
  },
  saveBanner: function (params) {
    return http.post('action/shop/config/save/banner', params)
  },
  deleteBanner: function (params) {
    return http.post('action/shop/config/delete/banner', params)
  },
  orderStatisticsByShop: function (params) {
    return http.post('action/admin/order/orderStatisticsByShop', params)
  },
  getRecentListByShop: function (params) {
    return http.post('action/admin/order/getRecentListByShop', params)
  },
}

export let category = {
  list: function (params) {
    return http.post('admin/category/getCategoryList', params)
  },
  add: function (params) {
    return http.post('admin/category/addCategory', params)
  },
  update: function (params) {
    return http.post('admin/category/updateCategory', params)
  },
  remove: function (params) {
    return http.post('admin/category/updateStatus', params)
  },
  queryProrebate: function (params) {
    return http.get('admin/config/query/prorebate', params)
  },
  updateProrebate: function (params) {
    return http.postBody('admin/config/update/prorebate', params)
  },
}
export let dispose = {
  list: function (params) {
    return http.post('action/sconfig/list', params)
  },
  update: function (params) {
    return http.postBody('action/sconfig/update', params)
  },
  versionList: function (params) {
    return http.post('admin/version/list', params)
  },
  save: function (params) {
    return http.post('admin/version/save', params)
  },
  versionUpdate: function (params) {
    return http.post('admin/version/update', params)
  },
  versionDelete: function (params) {
    return http.post('admin/version/delete', params)
  },
}
export let agent = {
  recordList: function (params) {
    return http.post('action/share/record/list', params)
  },
  agentList: function (params) {
    return http.post('action/agent/list', params)
  },
  setList: function (params) {
    return http.post('action/agent/set/list', params)
  },
  add: function (params) {
    return http.post('action/agent/set/add', params)
  },
  team: function (params) {
    return http.post('action/agent/team', params)
  },
  remove: function (params) {
    return http.post('action/agent/set/remove', params)
  },
}
export let shopManage = {
  list: function (params) {
    return http.get('action/shop/bank/list', params)
  },
  save: function (params) {
    return http.post('action/shop/bank/save', params)
  },
  delete: function (params) {
    return http.post('action/shop/bank/delete', params)
  },
  deletemore: function (params) {
    return http.post('action/shop/bank/deletemore', params)
  },
  getRefundAddrList: function (params) {
    return http.post('action/admin/refundAddr/getRefundAddrList', params)
  },
  addRefundAddr: function (params) {
    return http.postBody('action/admin/refundAddr/addRefundAddr', params)
  },
  updateRefundAddr: function (params) {
    return http.post('action/admin/refundAddr/updateRefundAddr', params)
  },
  deleteRefundAddr: function (params) {
    return http.post('action/admin/refundAddr/deleteRefundAddr', params)
  },
}
export let management = {
  companyinfolist: function (params) {
    return http.get('action/sconfig/query/companyinfolist', params)
  },
  save: function (params) {
    return http.post('action/sconfig/save/companyinfo', params)
  },
  delete: function (params) {
    return http.post('action/sconfig/delete/companyinfo', params)
  },
  update: function (params) {
    return http.post('action/sconfig/update/companyinfo', params)
  },
  consultList: function (params) {
    return http.post('action/consult/list', params)
  },
  allbanner: function (params) {
    return http.post('action/banner/allbanner', params)
  },
  insertbanner: function (params) {
    return http.post('action/banner/insertbanner', params)
  },
  updatebanner: function (params) {
    return http.post('action/banner/updatebanner', params)
  },
  deletebanner: function (params) {
    return http.get('action/banner/deletebanner', params)
  },
  deletemorebanner: function (params) {
    return http.get('action/banner/deletemorebanner', params)
  },
  helpcenterList: function (params) {
    return http.post('action/helpcenter/list', params)
  },
  helpcenterSave: function (params) {
    return http.post('action/helpcenter/save', params)
  },
  helpcenterDelete: function (params) {
    return http.post('action/helpcenter/delete', params)
  },
  helpcenterDeletemore: function (params) {
    return http.post('action/helpcenter/deletemore', params)
  },
  helpcenterUpdate: function (params) {
    return http.post('action/helpcenter/update', params)
  },
  queryType: function (params) {
    return http.get('action/user/issue/query/type', params)
  },
  inserType: function (params) {
    return http.post('action/user/issue/inser/type', params)
  },
  updateType: function (params) {
    return http.post('action/user/issue/update/type', params)
  },
  deleteType: function (params) {
    return http.post('action/user/issue/delete/type', params)
  },
  ruleList: function (params) {
    return http.post('action/rule/list', params)
  },
  ruleUpdate: function (params) {
    return http.post('action/rule/update', params)
  },
  consultUpdate: function (params) {
    return http.post('action/consult/update', params)
  },

}
export let distributor = {
  list: function (params) {
    return http.post('action/dealer/list', params)
  },
  setList: function (params) {
    return http.post("action/dealer/set/list", params)
  },
  save: function (params) {
    return http.post('action/dealer/set/add', params)
  },
  delete: function (params) {
    return http.post('action/dealer/set/remove', params)
  },
  update: function (params) {
    return http.post('action/dealer/set/update', params)
  },
  dealerTeam: function (params) {
    return http.post('action/dealer/team', params)
  },
}
export let express = {
  list: function (params) {
    return http.post('action/delivery/getDeliveryListAll', params)
  },
  address: function (params) {
    return http.get('action/area/list', params)
  },
}

export let feedback = {
  list: function (params) {
    return http.post('action/user/issue/list', params)
  },
  update: function (params) {
    return http.post('action/user/issue/update', params)
  },
  queryItem: function (params) {
    return http.get('action/user/issue/query/item', params)
  },
  suggestList: function (params) {
    return http.post('action/suggest/list', params)
  },
  reply: function (params) {
    return http.post('action/suggest/reply', params)
  },
}

export let finance = {
  withdrawList: function (params) {
    return http.post('action/shop/withdraw/record/shop/list', params)
  },
  withdrawSave: function (params) {
    return http.post('action/shop/withdraw/record/shop/save', params)
  },
  withdrawUpdate: function (params) {
    return http.post('action/shop/withdraw/record/admin/update', params)
  },
  getFinancialStatisticsByShop: function (params) {
    return http.post('action/admin/financialStatistics/getFinancialStatisticsByShop', params)
  },
  getTotalByShop: function (params) {
    return http.post('action/admin/financialStatistics/getTotalByShop', params)
  },
  rechargerecord: function (params) {
    return http.post('admin/query/rechargerecord', params)
  },
}

export let mall = {
  remindOrderList: function (params) {
    return http.post('action/admin/order/remindOrderList', params)
  },
  remindOrderListByShop: function (params) {
    return http.post('action/admin/order/remindOrderListByShop', params)
  },
  getShopList: function (params) {
    return http.post('admin/shop/getShopList', params)
  },
  getShopById: function (params) {
    return http.post('admin/shop/getShopById', params)
  },
  updateShop: function (params) {
    return http.post('admin/shop/updateShop', params)
  },
  updateStatus: function (params) {
    return http.post('admin/shop/updateStatus', params)
  },
  moreExamine: function (params) {
    return http.post('admin/shop/more/examine', params)
  },
  orderStatistics: function (params) {
    return http.post('action/admin/order/orderStatistics', params)
  },
  getRecentList: function (params) {
    return http.post('action/admin/order/getRecentList', params)
  },
}
export let branchOffice = {
  energyAdd: function (params) {
    return http.post('action/corp/set/energy/add', params)
  },
  energyList: function (params) {
    return http.post('action/corp/set/energy/list', params)
  },
  energyUpdate: function (params) {
    return http.post('action/corp/set/energy/update', params)
  },
  energyRemove: function (params) {
    return http.post('action/corp/set/energy/remove', params)
  },
  query: function (params) {
    return http.post('action/corp/set/install/query', params)
  },
  update: function (params) {
    return http.post('action/corp/set/install/update', params)
  },
  listCorp: function (params) {
    return http.post('action/admin/corp/listCorp', params)
  },
  listByCorpId: function (params) {
    return http.post('action/district/listByCorpId', params)
  },
  bindCorp: function (params) {
    return http.postBody('action/admin/corp/bindCorp', params)
  },
  parnterlist: function (params) {
    return http.post('action/admin/corp/parnterlist', params)
  },
}



// WEBPACK FOOTER //
// ./src/utils/api.js